import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import * as fromReducer from '@appStore/reducers';
import * as fromSelectors from '@appStore/selectors';
import { LoginRequired } from '@appStore/actions/core-auth/auth/auth.actions';
import { Nav } from '@appStore/actions/nav.actions';
import { nav } from '../../config/nav';

export interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}

export const ROUTES: RouteInfo[] = nav.main.identity;

@Injectable({ providedIn: 'root' })
export class IdentityGuard  {
  constructor(private store: Store<fromReducer.auth.State>) {}

  canActivate(next: ActivatedRouteSnapshot,state: RouterStateSnapshot): Observable<boolean> {
    return this.store.pipe(
      select(fromSelectors.isAuthenticated),
      map(authed => {
          if(state.url!='/identity-management/users/profile/settings'){
            this.store.dispatch(new Nav(ROUTES));
          }
          if (localStorage.getItem('authorization') !== null) {
              return true;
          }
          this.store.dispatch(new LoginRequired());
          return false ;
      })
    );
  }
}
